import { jsx as _jsx } from "react/jsx-runtime";
import { IconColor, IconName, IconSize, Link, LinkTarget, List, Text, TextSize } from '@as/cotopaxi';
export const AdvantagesSection = ({ items, textSize = TextSize.SMALL }) => {
    const renderContent = (item) => item.link ? (_jsx(Link, { href: item.link, target: item.linkOpensInNewTab ? LinkTarget.BLANK : null, children: item.text })) : (item.text);
    return (_jsx(List, { icon: {
            name: IconName.CHECK,
            color: IconColor.POSITIVE,
            size: IconSize.MAJOR,
        }, children: items.map((item) => (_jsx(List.Item, { children: _jsx(Text, { inline: true, size: textSize, children: renderContent(item) }) }, item.text.replace(/ /g, '')))) }));
};
